var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 18.9577C5.05964 18.9577 1.04297 14.941 1.04297 9.99935C1.04297 5.05768 5.05964 1.04102 10.0013 1.04102C14.943 1.04102 18.9596 5.05768 18.9596 9.99935C18.9596 14.941 14.943 18.9577 10.0013 18.9577Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3346 10.625H6.66797C6.3263 10.625 6.04297 10.3417 6.04297 10C6.04297 9.65833 6.3263 9.375 6.66797 9.375H13.3346C13.6763 9.375 13.9596 9.65833 13.9596 10C13.9596 10.3417 13.6763 10.625 13.3346 10.625Z",
    fill: "#0D6CF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.9577C9.65833 13.9577 9.375 13.6743 9.375 13.3327V6.66602C9.375 6.32435 9.65833 6.04102 10 6.04102C10.3417 6.04102 10.625 6.32435 10.625 6.66602V13.3327C10.625 13.6743 10.3417 13.9577 10 13.9577Z",
    fill: "#0D6CF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusFill);
export default __webpack_public_path__ + "static/media/plus_fill.8e3c3c12c40bea1b63b5938a634ca698.svg";
export { ForwardRef as ReactComponent };